import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, List } from '../../../components';

import '../OnboardingForm.css';
import { paymentOptionsAPI } from '../merchantApi';
import PaymentHistryItem from './PaymentHistryItem';
import PaymentHistoryList from './PaymentHistoryList';

const formClassname = 'onboarding-form';
const ns = 'configurations';
const PaymentOptionList = ({ storeId }: any) => {
  const { token } = useSelector((state: any) => state.user);
  const [loading, setLoading] = useState(false);
  const [paymentOptionsList, setPaymentOptionsList] = useState<any>();
  const [selectedOption, setSelectedOption] = useState<any>();
  const [paymentHistoryModal, setPaymentHistoryModal] = useState(false);
  useEffect(() => {
    paymentOptionsAPI({
      storeId,
      token,
      setLoading,
      setPaymentOptionsList,
    });
  }, [storeId]);

  return (
    <div className={ns}>
      <div className={`${formClassname}__line`}>
        <strong className={`${formClassname}__label-text`}>
          Add or remove store payment options
        </strong>
      </div>
      <Box withHeader>
        <div className={`${ns}__headers`}>
          <p>Option</p>
          <p>Order fee</p>
          <p>Service fee</p>
          <p>Start date</p>
          <p>Max. order value</p>
          <p>Min. order value</p>
          <p />
        </div>

        <List
          isLoading={loading}
          data={paymentOptionsList}
          component={(data: any) =>
            PaymentHistryItem({
              ...data,
              setSelectedOption,
              setPaymentHistoryModal,
            })
          }
        />

        <PaymentHistoryList
          storeId={storeId}
          subProductType={selectedOption}
          onClose={() => setPaymentHistoryModal(false)}
          isVisible={paymentHistoryModal}
        />
      </Box>
    </div>
  );
};

export default PaymentOptionList;
